import {
  Button, Tooltip, Menu, MenuItem, ListItemIcon, ListItemText, Stack, useMediaQuery, useTheme
} from "@mui/material";
import {NavLink} from "react-router-dom";
import React, {useState} from "react";
import {sidebarMenuItems} from "../../pages/project/flow/initialState";

export const SidebarMenu = ({project, userRole = "ADMIN"}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuItems, setSubmenuItems] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleOpenSubmenu = (event, items) => {
    setAnchorEl(event.currentTarget);
    setSubmenuItems(items);
  };

  const handleCloseSubmenu = () => {
    setAnchorEl(null);
    setSubmenuItems([]);
  };

  return (
    <Stack
      direction={"column"} gap={1.5}
      sx={{
        maxHeight: '100%',
        minWidth: "48px",
        maxWidth: "48px",
        width: "100%",
        borderRight: 1,
        pb: 0.5,
        pt: 1,
        px: 0.5,
        borderColor: "divider",
        // backgroundColor: "#f1f4f7",
        overflowY: "auto",
      }}>
      {sidebarMenuItems
        .filter(item => item.roles.includes(userRole))
        .filter(item => !(isMobile && item.hideOnMobile))
        .map((item, idx) => {
          const isDisabled = typeof item.disabled === 'function' ? item.disabled(project) : false;
          if (item.submenu) {
            return (
              <Tooltip key={idx} title={item.label} placement={"right"}>
                <Button
                  sx={{minWidth: 40, color: "primary.dark"}}
                  className={"side-link"}
                  onClick={(e) => handleOpenSubmenu(e, item.submenu)}
                >
                  {item.icon}
                </Button>
              </Tooltip>
            );
          }

          return (
            <Tooltip key={idx} title={item.label} placement={"right"}>
              <Button
                component={NavLink}
                end
                to={item.to(project)}
                disabled={isDisabled}
                sx={{minWidth: 40, color: "primary.dark"}}
                className={"side-link"}
              >
                {item.icon}
              </Button>
            </Tooltip>
          );
        })}

      {/* Submenu as MUI Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseSubmenu}
        slotProps={{
          paper: {
            sx: {
              p: 1, borderRadius: 3,
              minWidth: 200
            }
          }
        }}
      >
        {submenuItems
          .filter(sub => sub.roles.includes(userRole))
          .map((sub, idx) => (
            <MenuItem
              key={idx}
              component={NavLink}
              to={sub.to(project)}
              onClick={handleCloseSubmenu}
              className={"side-link"}
            >
              <ListItemIcon>{sub.icon}</ListItemIcon>
              <ListItemText primary={sub.label}/>
            </MenuItem>
          ))}
      </Menu>
    </Stack>
  );
};
